<template>
    <div class="PC-customize configurable-products">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-9">
                    <div class="inside-config" id="example-content">
                        <span>
                            <h2>{{ configurableProducts.persianName }}</h2>
                            <h3>{{ configurableProducts.name }}</h3>
                        </span>
                        <div class="group"
                             v-for="group in configurableProducts.configurableProductItemsGroupedByGenericDto"
                             :key="group">
                            <div class="group-icon"></div>
                            <div class="row title">
                                <h4 class="ml-4">{{ group.genericName }}</h4>
                                <p>باید  {{group.saleAttributeInfoDtoInfo.count}} عدد از {{group.saleConfigurableProductItemsDto.length}} نوع ارائه شده انتخاب گردد.</p>
                            </div>
                            <ul class="offered-product">
                                <li :class="{ selected: selectedProduct.includes(product) }"
                                    v-for="(
                    product, index
                  ) in group.saleConfigurableProductItemsDto"
                                    :key="index"
                                    class="row">
                                    <a :href="'/Product/' + product.actualProductId" target="_blank" class="mr-1">
                                        <img :src="
                        'https://asset.avajang.com/Product/' + product.imageUri
                      "
                                             width="80px"
                                             height="80px" />
                                    </a>
                                    <div class="col info-col" @click="selectionProduct(product)">
                                        <h4>{{ product.persianName }}</h4>
                                        <h5>{{ product.englishName }}</h5>
                                    </div>
                                    <div class="col-2 d-inline-block my-auto d-flex justify-content-center"
                                         v-if="product.Count != 0">
                                        <button v-show="product.selectOption != 1 && product.selectOption != group.saleConfigurableProductItemsDto.length "
                                                class="btn Decrease"
                                                @click="DecreaseCount(product)">
                                            -
                                        </button>
                                        <input type="text"
                                               class="dropbtn"
                                               disabled
                                               :value="product.Count"
                                               v-if="product.Count == 1" />
                                        <button v-show="product.selectOption != 1 && product.selectOption != group.saleConfigurableProductItemsDto.length "
                                                class="btn Increase"
                                                @click="IncreaseCount(product)">
                                            +
                                        </button>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <affix class="sidebar-menu"
                           relative-element-selector="#example-content"
                           width="calc(25% - 30px)"
                           :offset="{ top: 100, bottom: 0 }">
                        <div class="config-cart">
                            <div class="total-cartprice">
                                <span>مجموع خرید:</span>
                                <div class="total-price green-style">
                                    {{
                    (totalPrice / 10).toLocaleString() | toPersianNumber
                                    }}تومان
                                </div>
                            </div>
                            <button type="button"
                                    @click.prevent="createBasket()"
                                    class="add-to-cart">
                                افزودن به سبد‌ خرید
                            </button>
                        </div>
                        <div id="choosen-items">
                            <h4>موارد انتخابی</h4>
                            <ul>
                                <template v-for="(selected ) in selectedProduct">
                                    <span :key="selected">
                                        <li v-if="selected.Count != 0">
                                            {{ selected.persianName }}
                                            <h6>( تعداد * {{ selected.Count }} )</h6>
                                        </li>
                                    </span>
                                </template>

                            </ul>
                        </div>
                    </affix>
                </div>
            </div>
            <div id="cp-loading" v-if="loading">
                <div class="loader">
                    <div class="page-loading">
                        <div></div>
                        <div></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { mapActions } from "vuex";
    import { PRODUCT_LIST_CONSTANTS } from "@/constants/constants.js";
    import { PRODUCT_LIST_PATHS } from "@/constants/storePaths.js";
    import { Affix } from "vue-affix";
    import axios from "axios";

    export default Vue.extend({
        data() {
            return {
                SameType: [],
                TempTotalCount: 0,
                configurableProducts: [],
                selectedProduct: [],
                totalPrice: null,
                price: null,
                loading: false,
                contractId: PRODUCT_LIST_CONSTANTS.defaultContractId,
                configurableProductId: this.$route.params.id,
                model: {},
                allPossibleProducts: []
            };
        },
        mounted() {
            this.fetchConfigurableProducts(this.configurableProductId).then(
                (response) => (
                    (this.configurableProducts = JSON.parse(JSON.stringify(response.data))),
                    this.load()
                )
            );
        },
        methods: {
            ...mapActions({
                fetchConfigurableProducts: PRODUCT_LIST_PATHS.fetchConfigurableProducts,
            }),
            load() {
                debugger;
                this.price = this.configurableProducts.price;
                var configurableProductItemsGroupe =
                    this.configurableProducts.configurableProductItemsGroupedByGenericDto;
                var z = 0
                for (let i = 0; i < configurableProductItemsGroupe.length; i++) {
                    var tempallPossibleProducts = configurableProductItemsGroupe[i].saleConfigurableProductItemsDto
                    for (let j = 0; j < tempallPossibleProducts.length; j++) {
                        this.allPossibleProducts[z] = tempallPossibleProducts[j]
                        z++
                    }
                }
                debugger
                configurableProductItemsGroupe.forEach((elem) => {
                    this.selectedProduct.push(elem.saleConfigurableProductItemsDto[0]);
                });
                debugger

                for (let index = 0; index < this.selectedProduct.length; index++) {
                    this.selectedProduct[index].selectOption =
                        this.configurableProducts.configurableProductItemsGroupedByGenericDto[
                            index
                        ].saleAttributeInfoDtoInfo.selectOption;
                    this.selectedProduct[index].Count = 1;
                    this.selectedProduct[index].MaxCount =
                        this.configurableProducts.configurableProductItemsGroupedByGenericDto[
                            index
                        ].saleAttributeInfoDtoInfo.count;
                    this.selectedProduct[index].TotalCountSameType = 1;
                }
                debugger
                for (let pp = 0; pp < this.selectedProduct.length; pp++) {
                    for (let qq = 0; qq < this.allPossibleProducts.length; qq++) {
                        if (this.allPossibleProducts[qq].genericName == this.selectedProduct[pp].genericName) {
                            if (this.allPossibleProducts[qq].Count != 1) {
                                if (this.selectedProduct[pp].selectOption == 2) {
                                    if (this.selectedProduct[pp].TotalCountSameType < this.selectedProduct[pp].MaxCount) {
                                        this.allPossibleProducts[qq].Count = 1
                                        this.selectedProduct[pp].TotalCountSameType++
                                        this.selectedProduct.push(this.allPossibleProducts[qq]);
                                    } else {
                                        this.allPossibleProducts[qq].Count = 0
                                    }
                                }
                                this.allPossibleProducts[qq].TotalCountSameType = this.selectedProduct[pp].TotalCountSameType
                                this.allPossibleProducts[qq].MaxCount = this.selectedProduct[pp].MaxCount
                                this.allPossibleProducts[qq].selectOption = this.selectedProduct[pp].selectOption
                            }
                        } debugger
                    } debugger
                } debugger
                this.calcTotalPrice();
            },
            calcTotalPrice() {
                debugger;
                this.totalPrice = 0;
                for (let index = 0; index < this.selectedProduct.length; index++) {
                    this.totalPrice = this.selectedProduct[index].price * this.selectedProduct[index].Count + this.totalPrice;
                }
                for (let cc = 0; cc < this.selectedProduct.length; cc++) {
                    if (this.selectedProduct[cc].Count == 0) {
                        this.selectedProduct.splice(cc, 1);
                    }
                }
                debugger
            },
            selectionProduct(product) {
                debugger;
                if (product.MaxCount <= product.TotalCountSameType) {
                    for (let index = 0; index < this.allPossibleProducts.length; index++) {
                        if (product.itemCode == this.allPossibleProducts[index].itemCode) {
                            var z = index
                        }
                    }
                    if (this.allPossibleProducts[z].selectOption == 1) {
                        this.AddNewGender(product);
                        debugger
                        for (let index = 0; index < this.allPossibleProducts.length; index++) {
                            if (this.allPossibleProducts[index].genericName == product.genericName) {
                                if (this.allPossibleProducts[index].itemCode == product.itemCode) {
                                    this.allPossibleProducts[index].Count = 1
                                } else
                                    this.allPossibleProducts[index].Count--

                            }
                        }
                        this.calcTotalPrice();
                    } else
                        alert("تعداد " + product.genericName + " در مجموع حداکثر " + product.MaxCount + " است.")
                }
                else {
                    debugger
                    this.AddNewGender(product)
                    this.calcTotalPrice();
                    debugger
                }

            },
            AddNewGender(productInfo) {
                debugger;
                this.selectedProduct.push(productInfo);
                for (let index = 0; index < this.allPossibleProducts.length; index++) {
                    if (this.allPossibleProducts[index].genericName == productInfo.genericName) {
                        if (this.allPossibleProducts[index].itemCode == productInfo.itemCode) {
                            this.allPossibleProducts[index].Count++
                        }
                        this.allPossibleProducts[index].TotalCountSameType++
                    }
                }
            },
            EqualizeAndClacTotalCountSameType(productInfo) {
                debugger;
                var j = 0;
                this.TempTotalCount = 0;
                for (let index = 0; index < this.selectedProduct.length; index++) {
                    if (productInfo.genericId == this.selectedProduct[index].genericId) {
                        this.SameType[j] = index;
                        this.TempTotalCount += this.selectedProduct[index].Count;
                        j++;
                    }
                }
                for (let index = 0; index < j; index++) {
                    this.selectedProduct[this.SameType[index]].TotalCountSameType =
                        this.TempTotalCount;
                }
            },
            DecreaseCount(product) {
                debugger;
                if (product.TotalCountSameType > 1) {
                    if (product.Count > 0) {
                        for (let hh = 0; hh < this.allPossibleProducts.length; hh++) {
                            if (this.allPossibleProducts[hh].genericName == product.genericName) {
                                if (product.itemCode == this.allPossibleProducts[hh].itemCode)
                                    this.allPossibleProducts[hh].Count--
                                this.allPossibleProducts[hh].TotalCountSameType--
                            }
                        }
                        this.calcTotalPrice();
                    } else { }
                } else
                    alert("تعداد " + product.genericName + " حداقل یک باید باشد");
            },
            IncreaseCount(product) {
                debugger
                if (product.MaxCount <= product.TotalCountSameType) {
                    alert("تعداد " + product.genericName + " در مجموع حداکثر " + product.MaxCount + " است.")
                }
                else {
                    debugger
                    for (let hh = 0; hh < this.allPossibleProducts.length; hh++) {
                        if (this.allPossibleProducts[hh].genericName == product.genericName) {
                            if (product.itemCode == this.allPossibleProducts[hh].itemCode)
                                this.allPossibleProducts[hh].Count++
                            this.allPossibleProducts[hh].TotalCountSameType++
                        }
                    }
                    this.calcTotalPrice();
                }
                debugger;
            },
            createModel() {
                debugger;
                this.model = [];
                var Items = this.selectedProduct;
                this.model = {
                    ContractId: this.contractId,
                    ProductId: this.configurableProductId,
                    Count: 1,
                    InternalBasketItems: [],
                };
                Items.forEach((elem) => {
                    this.model.InternalBasketItems.push({
                        ContractId: this.contractId,
                        ProductId: elem.specificProductId,
                        Count: elem.Count,
                    });
                });
                console.log("####");
                console.log(this.model.InternalBasketItems);
            },
            createBasket() {
                debugger;
                this.createModel();
                this.loading = true;
                axios
                    .put("/Basket/Put", this.model)
                    .then((response) => {
                        this.$swal({
                            position: "center-center",
                            type: "success",
                            html: '<div class="product-added"><div class="green"> <span class="avafont-checkmark"></span>محصول مورد نظر</div> با موفقیت به سبد خرید شما افزوده شد.<div class="buttons"><button class="close-alert btn-cancel"  type="button">ادامه خرید</button><a id ="btn_redirect_to_basket" href="#"  class="next">نهایی‌سازی سبد خرید</a> </div></div>',
                            showConfirmButton: false,
                            onBeforeOpen: () => {
                                const cancel = document.querySelector(".btn-cancel");
                                cancel.addEventListener("click", () => {
                                    this.$swal.close();
                                });
                            },
                        });
                        this.loading = false;
                    })
                    .catch((error) => {
                        this.$swal({
                            position: "center-center",
                            type: "error",
                            text: error.request.response,
                            showConfirmButton: false,
                            timer: 8000,
                        });
                        this.loading = false;
                    });
            },
        },
        components: {
            Affix,
        },
    });
</script>
